import React from "react";

const UnauthorizedPage: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center text-center">
    <p className="text-lg font-medium text-red-600">
      You are not authorized to access this page.
    </p>
  </div>
);

export default UnauthorizedPage;